const MaxZoomLgvIcon = ({ color, angle, vehicleNumber, isFollowing }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 17 10"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      transform="matrix(1,0,0,-1,0,0)"
      style={{
        transform: `rotate(${angle}deg)`,
        transformOrigin: "center center",
      }}
    >
      <path
        d="M15.1818 8.59553L7.94892 8.59553C7.85814 8.59553 7.78455 8.66912 7.78455 8.75989L7.78455 8.83564C7.78455 8.92641 7.71097 9 7.62019 9L5.16436 9C5.07359 9 5 8.92641 5 8.83564L5 1.16436C5 1.07359 5.07359 1 5.16436 1L7.62019 1C7.71097 1 7.78455 1.07359 7.78455 1.16436L7.78455 1.2735C7.78455 1.36427 7.85814 1.43786 7.94892 1.43786L15.1858 1.43786C15.2477 1.43786 15.3044 1.47221 15.3312 1.52798C16.3029 3.54438 16.1396 6.66382 15.3296 8.50064C15.3038 8.55916 15.2458 8.59553 15.1818 8.59553Z"
        stroke={color}
        strokeWidth="0.245304"
      />
      <text
        fill="white"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="4"
        x="-12.5"
        y="5.25"
        transform="scale(-1,1)"
      >
        {vehicleNumber}
      </text>
      <rect
        x="5.35547"
        y="7.7168"
        width="0.415914"
        height="5.86197"
        rx="0.0991453"
        transform="rotate(180 5.35547 7.7168)"
        fill={color}
      />
      <rect
        x="4.63843"
        y="8.31641"
        width="0.493088"
        height="0.328725"
        transform="rotate(180 4.63843 8.31641)"
        fill={color}
      />
      <path
        d="M4.72412 8.14926C4.72412 8.19465 4.68733 8.23145 4.64194 8.23145L0.0821815 8.23145C0.0367941 8.23145 -3.21662e-09 8.19465 -7.18452e-09 8.14926V8.14926C-1.11524e-08 8.10388 0.0367938 8.06708 0.0821813 8.06708L4.64194 8.06708C4.68733 8.06708 4.72412 8.10388 4.72412 8.14926V8.14926Z"
        fill={color}
      />
      <rect
        x="4.63843"
        y="6.67188"
        width="0.493088"
        height="0.328725"
        transform="rotate(180 4.63843 6.67188)"
        fill={color}
      />
      <path
        d="M4.63501 6.49985C4.63501 6.54524 4.59822 6.58203 4.55283 6.58203L0.0821815 6.58203C0.036794 6.58203 -3.21662e-09 6.54524 -7.18452e-09 6.49985V6.49985C-1.11524e-08 6.45446 0.0367938 6.41767 0.0821813 6.41767L4.55283 6.41767C4.59822 6.41767 4.63501 6.45446 4.63501 6.49985V6.49985Z"
        fill={color}
      />
      <rect
        x="4.63843"
        y="3.05566"
        width="0.493088"
        height="0.328725"
        transform="rotate(180 4.63843 3.05566)"
        fill={color}
      />
      <rect
        x="4.63843"
        y="1.57715"
        width="0.493088"
        height="0.328725"
        transform="rotate(180 4.63843 1.57715)"
        fill={color}
      />
      <path
        d="M4.71704 1.40805C4.71704 1.45344 4.68025 1.49023 4.63486 1.49023L0.0821815 1.49023C0.036794 1.49023 -3.21662e-09 1.45344 -7.18452e-09 1.40805V1.40805C-1.11524e-08 1.36267 0.0367938 1.32587 0.0821813 1.32587L4.63486 1.32587C4.68025 1.32587 4.71704 1.36267 4.71704 1.40805V1.40805Z"
        fill={color}
      />
      <rect
        x="4.93945"
        y="8.34082"
        width="0.415914"
        height="7.10377"
        rx="0.0991453"
        transform="rotate(180 4.93945 8.34082)"
        fill={color}
      />
      <path
        d="M8.3064 1.37207L9.39917 1.37207L9.39917 8.69141L8.3064 8.69141L8.3064 1.37207ZM8.87378 2.96875C9.04051 2.96875 9.17536 2.83368 9.17554 2.66699C9.17554 2.50016 9.04061 2.36426 8.87378 2.36426C8.70702 2.36435 8.57202 2.50021 8.57202 2.66699C8.5722 2.83362 8.70713 2.96866 8.87378 2.96875ZM8.87378 4.04102C9.04051 4.04102 9.17536 3.90594 9.17554 3.73926C9.17554 3.57242 9.04061 3.43652 8.87378 3.43652C8.70702 3.43661 8.57202 3.57248 8.57202 3.73926C8.5722 3.90589 8.70713 4.04093 8.87378 4.04102ZM8.87378 5.11426C9.04051 5.11426 9.17536 4.97919 9.17554 4.8125C9.17554 4.64566 9.04061 4.50977 8.87378 4.50977C8.70702 4.50985 8.57202 4.64572 8.57202 4.8125C8.5722 4.97913 8.70713 5.11417 8.87378 5.11426ZM8.87378 6.18652C9.04051 6.18652 9.17536 6.05145 9.17554 5.88477C9.17554 5.71793 9.04062 5.58203 8.87378 5.58203C8.70702 5.58212 8.57202 5.71798 8.57202 5.88477C8.5722 6.0514 8.70713 6.18644 8.87378 6.18652ZM8.87378 7.25879C9.04051 7.25879 9.17536 7.12372 9.17554 6.95703C9.17554 6.7902 9.04062 6.6543 8.87378 6.6543C8.70702 6.65438 8.57202 6.79025 8.57202 6.95703C8.5722 7.12366 8.70713 7.2587 8.87378 7.25879Z"
        fill="white"
      />
      <path
        d="M4.46021 2.88777C4.46021 2.93088 4.42526 2.96582 4.38215 2.96582L0.0780511 2.96582C0.0349447 2.96582 -3.05496e-09 2.93088 -6.82345e-09 2.88777V2.88777C-1.05919e-08 2.84466 0.0349447 2.80972 0.0780511 2.80972L4.38215 2.80972C4.42526 2.80972 4.46021 2.84466 4.46021 2.88777V2.88777Z"
        fill={color}
      />
    </svg>
    {isFollowing && (
      <span id="lgv-wrapper-circle">
        <span className="lgv-wrapper-circle-outer"></span>
        <span className="lgv-wrapper-circle-inner"></span>
      </span>
    )}
  </div>
);

export default MaxZoomLgvIcon;
